import { render, staticRenderFns } from "./orderDialog.vue?vue&type=template&id=e85859fa&scoped=true"
import script from "./orderDialog.vue?vue&type=script&lang=js"
export * from "./orderDialog.vue?vue&type=script&lang=js"
import style0 from "./orderDialog.vue?vue&type=style&index=0&id=e85859fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85859fa",
  null
  
)

export default component.exports